import type { ListView } from '@app/constants/list-views';

/** Verified Atlas documentation destinations. Omitted entries render no help link. */
export const LIST_VIEW_DOCS_URL: Partial<Record<ListView, string>> = {};
